import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardV2, CardBody, CardContent, Col, LoaderMi, Row } from '@design-system-etat/dsfr-react';
import styles from './VisualiserPhotoIdentite.module.scss';
import DisplayFileFromBack from '../../Image/DisplayFileFromBack';

const VisualiserPhotoIdentite = ({ titre, photoIdentite }) => {
    const [fileToDisplay, setFileToDisplay] = useState(null);

    useEffect(() => {
        if (photoIdentite && photoIdentite.uuid) {
            const getImage = async () => {
                const dataImage = await DisplayFileFromBack(photoIdentite.uuid);
                setFileToDisplay(dataImage);
            };
            getImage();
        }
    }, [photoIdentite]);

    return (
        <>
            <CardV2 taille="lg" noEnlargeLink>
                <CardBody>
                    <CardContent>
                        {titre && (
                            <Row>
                                <Col col={12}>
                                    <div className={styles.photoIdentite__titre}>
                                        <span
                                            className="fr-icon-camera-fill icon-color"
                                            aria-hidden="true"
                                        />{' '}
                                        {titre}
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {!fileToDisplay ? (
                            <div className={styles.photoIdentite__containerLoader}>
                                <LoaderMi taille="md" />
                            </div>
                        ) : (
                            <div className={styles.photoIdentite__imgContainer}>
                                <img
                                    src={fileToDisplay.contenu}
                                    width="180"
                                    alt={fileToDisplay.libelle}
                                />
                            </div>
                        )}
                    </CardContent>
                </CardBody>
            </CardV2>
        </>
    );
};

VisualiserPhotoIdentite.propTypes = {
    titre: PropTypes.string,
    photoIdentite: PropTypes.object,
};

export default VisualiserPhotoIdentite;
